// source: pushwoosh/objects/restrictionValues/v1/model.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue', null, global);
goog.exportSymbol('proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal.displayName = 'proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.displayName = 'proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal.toObject = function(includeInstance, msg) {
  var f, obj = {
    f1: (f = msg.getF1()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    f2: (f = msg.getF2()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal}
 */
proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal;
  return proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal}
 */
proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setF1(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setF2(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getF1();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getF2();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue f1 = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal.prototype.getF1 = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal} returns this
*/
proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal.prototype.setF1 = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal.prototype.clearF1 = function() {
  return this.setF1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal.prototype.hasF1 = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp f2 = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal.prototype.getF2 = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal} returns this
*/
proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal.prototype.setF2 = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal.prototype.clearF2 = function() {
  return this.setF2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.__restrictionValue_model_internal.prototype.hasF2 = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    islocked: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    maxcampaigns: jspb.Message.getFieldWithDefault(msg, 3, 0),
    maxdeeplinks: jspb.Message.getFieldWithDefault(msg, 4, 0),
    maxapplicationgroups: jspb.Message.getFieldWithDefault(msg, 5, 0),
    maxapps: jspb.Message.getFieldWithDefault(msg, 6, 0),
    maxtags: jspb.Message.getFieldWithDefault(msg, 7, 0),
    maxgeozones: jspb.Message.getFieldWithDefault(msg, 8, 0),
    maxdevices: jspb.Message.getFieldWithDefault(msg, 9, 0),
    maxusers: jspb.Message.getFieldWithDefault(msg, 10, 0),
    maxapitokens: jspb.Message.getFieldWithDefault(msg, 11, 0),
    maxpresets: jspb.Message.getFieldWithDefault(msg, 12, 0),
    maxtestdevices: jspb.Message.getFieldWithDefault(msg, 13, 0),
    maxgeozonerange: jspb.Message.getFieldWithDefault(msg, 14, 0),
    maxrssfeeds: jspb.Message.getFieldWithDefault(msg, 16, 0),
    maxautopushes: jspb.Message.getFieldWithDefault(msg, 17, 0),
    maxioscategories: jspb.Message.getFieldWithDefault(msg, 18, 0),
    maxtwitterfeeds: jspb.Message.getFieldWithDefault(msg, 19, 0),
    maxinapps: jspb.Message.getFieldWithDefault(msg, 20, 0),
    maxevents: jspb.Message.getFieldWithDefault(msg, 21, 0),
    maxcreatemessage: jspb.Message.getFieldWithDefault(msg, 22, 0),
    maxrichmedia: jspb.Message.getFieldWithDefault(msg, 23, 0),
    maxpreparedfilters: jspb.Message.getFieldWithDefault(msg, 24, 0),
    maxfilters: jspb.Message.getFieldWithDefault(msg, 25, 0),
    devicesinactivitylimit: jspb.Message.getFieldWithDefault(msg, 26, 0),
    allowapi: jspb.Message.getBooleanFieldWithDefault(msg, 27, false),
    allowstatsaccess: jspb.Message.getBooleanFieldWithDefault(msg, 28, false),
    allowapistatsaccess: jspb.Message.getBooleanFieldWithDefault(msg, 29, false),
    allowgeozoneapi: jspb.Message.getBooleanFieldWithDefault(msg, 30, false),
    allowabtests: jspb.Message.getBooleanFieldWithDefault(msg, 32, false),
    allowbackup: jspb.Message.getBooleanFieldWithDefault(msg, 34, false),
    allowapplicationapi: jspb.Message.getBooleanFieldWithDefault(msg, 36, false),
    allowremotepage: jspb.Message.getBooleanFieldWithDefault(msg, 37, false),
    allowscheduling: jspb.Message.getBooleanFieldWithDefault(msg, 39, false),
    allowcustomdata: jspb.Message.getBooleanFieldWithDefault(msg, 40, false),
    allowmultilanguage: jspb.Message.getBooleanFieldWithDefault(msg, 41, false),
    allowautoconfig: jspb.Message.getBooleanFieldWithDefault(msg, 42, false),
    allowcsvmessage: jspb.Message.getBooleanFieldWithDefault(msg, 43, false),
    allowcampaignapi: jspb.Message.getBooleanFieldWithDefault(msg, 44, false),
    allowpushhistoryapi: jspb.Message.getBooleanFieldWithDefault(msg, 45, false),
    allowtagsapi: jspb.Message.getBooleanFieldWithDefault(msg, 46, false),
    allowpushbyuser: jspb.Message.getBooleanFieldWithDefault(msg, 47, false),
    allowfilterapi: jspb.Message.getBooleanFieldWithDefault(msg, 48, false),
    allowtwofactorauth: jspb.Message.getBooleanFieldWithDefault(msg, 49, false),
    allowbroadcastmessagesegmentation: jspb.Message.getBooleanFieldWithDefault(msg, 51, false),
    allowpushonevent: jspb.Message.getBooleanFieldWithDefault(msg, 52, false),
    allowcompilefilter: jspb.Message.getBooleanFieldWithDefault(msg, 53, false),
    minsendrate: jspb.Message.getFieldWithDefault(msg, 54, 0),
    maxsendrate: jspb.Message.getFieldWithDefault(msg, 55, 0),
    allowsendtogeozone: jspb.Message.getBooleanFieldWithDefault(msg, 56, false),
    allowuseiosnewsstand: jspb.Message.getBooleanFieldWithDefault(msg, 57, false),
    allowgetusersdetails: jspb.Message.getBooleanFieldWithDefault(msg, 58, false),
    allowgoaltracking: jspb.Message.getBooleanFieldWithDefault(msg, 59, false),
    allowieplatformusage: jspb.Message.getBooleanFieldWithDefault(msg, 60, false),
    allowinbox: jspb.Message.getBooleanFieldWithDefault(msg, 65, false),
    maxemailtemplates: jspb.Message.getFieldWithDefault(msg, 66, 0),
    maxuserspecifictags: jspb.Message.getFieldWithDefault(msg, 67, 0),
    allowgdpr: jspb.Message.getBooleanFieldWithDefault(msg, 68, false),
    maxverifyingemails: jspb.Message.getFieldWithDefault(msg, 69, 0),
    maxverifyingdomains: jspb.Message.getFieldWithDefault(msg, 70, 0),
    allowsendexternalstats: jspb.Message.getBooleanFieldWithDefault(msg, 71, false),
    allowcustomrsspollinginterval: jspb.Message.getBooleanFieldWithDefault(msg, 72, false),
    allowmetadata: jspb.Message.getBooleanFieldWithDefault(msg, 73, false),
    maxpushoneventdelayindays: jspb.Message.getFieldWithDefault(msg, 75, 0),
    alloweventstatisticsapi: jspb.Message.getBooleanFieldWithDefault(msg, 76, false),
    allowtagnotsetfilter: jspb.Message.getBooleanFieldWithDefault(msg, 77, false),
    allowdebugmode: jspb.Message.getBooleanFieldWithDefault(msg, 79, false),
    allowfbmessenger: jspb.Message.getBooleanFieldWithDefault(msg, 80, false),
    allowtrackuninstalls: jspb.Message.getBooleanFieldWithDefault(msg, 82, false),
    emailratecounteraggregateperiod: jspb.Message.getFieldWithDefault(msg, 84, 0),
    emailbounceratelimit: jspb.Message.getFieldWithDefault(msg, 85, 0),
    emailcomplaintratelimit: jspb.Message.getFieldWithDefault(msg, 86, 0),
    allowfrequencycapping: jspb.Message.getBooleanFieldWithDefault(msg, 87, false),
    maxusersperdevice: jspb.Message.getFieldWithDefault(msg, 88, 0),
    emailsfreelimit: jspb.Message.getFieldWithDefault(msg, 89, 0),
    emailslimited: jspb.Message.getBooleanFieldWithDefault(msg, 90, false),
    allowcontenttemplates: jspb.Message.getBooleanFieldWithDefault(msg, 94, false),
    allowbaiduandroidplatformusage: jspb.Message.getBooleanFieldWithDefault(msg, 95, false),
    maxinboxttldays: jspb.Message.getFieldWithDefault(msg, 97, 0),
    messagehistorystoreperiod: jspb.Message.getFieldWithDefault(msg, 105, 0),
    allowapigetmessagelog: jspb.Message.getBooleanFieldWithDefault(msg, 106, false),
    detailactionhistorystoreperiod: jspb.Message.getFieldWithDefault(msg, 107, 0),
    allowcjwebhook: jspb.Message.getBooleanFieldWithDefault(msg, 108, false),
    allowcjinapp: jspb.Message.getBooleanFieldWithDefault(msg, 109, false),
    allowcjscheduledsegment: jspb.Message.getBooleanFieldWithDefault(msg, 110, false),
    allowcjcontentpersonalization: jspb.Message.getBooleanFieldWithDefault(msg, 111, false),
    allowcjsettags: jspb.Message.getBooleanFieldWithDefault(msg, 112, false),
    allowcjdynamicdelay: jspb.Message.getBooleanFieldWithDefault(msg, 113, false),
    allowcjsilenthours: jspb.Message.getBooleanFieldWithDefault(msg, 114, false),
    allowcjfrequencycapping: jspb.Message.getBooleanFieldWithDefault(msg, 115, false),
    allowshowdeliverystatistics: jspb.Message.getBooleanFieldWithDefault(msg, 116, false),
    allowrfmsegments: jspb.Message.getBooleanFieldWithDefault(msg, 117, false),
    allowbesttimetosend: jspb.Message.getBooleanFieldWithDefault(msg, 118, false),
    alloweventsegmentation: jspb.Message.getBooleanFieldWithDefault(msg, 119, false),
    allowsegmentsgroups: jspb.Message.getBooleanFieldWithDefault(msg, 120, false),
    allowcustomerjourney: jspb.Message.getBooleanFieldWithDefault(msg, 121, false),
    allowcjsms: jspb.Message.getBooleanFieldWithDefault(msg, 122, false),
    allowcjapientry: jspb.Message.getBooleanFieldWithDefault(msg, 123, false),
    allowcjdynamicsettagsinupdateprofile: jspb.Message.getBooleanFieldWithDefault(msg, 124, false),
    allowcjaddbranchesinwaitfortrigger: jspb.Message.getBooleanFieldWithDefault(msg, 125, false),
    alloweventsfunnel: jspb.Message.getBooleanFieldWithDefault(msg, 126, false),
    allowchannelssection: jspb.Message.getBooleanFieldWithDefault(msg, 127, false),
    allowcjemailbcc: jspb.Message.getBooleanFieldWithDefault(msg, 128, false),
    emailfilestoreperiod: jspb.Message.getFieldWithDefault(msg, 129, 0),
    allowwhatsapp: jspb.Message.getBooleanFieldWithDefault(msg, 130, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue;
  return proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIslocked(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxcampaigns(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxdeeplinks(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxapplicationgroups(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxapps(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxtags(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxgeozones(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxdevices(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxusers(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxapitokens(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxpresets(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxtestdevices(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxgeozonerange(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxrssfeeds(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxautopushes(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxioscategories(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxtwitterfeeds(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxinapps(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxevents(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxcreatemessage(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxrichmedia(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxpreparedfilters(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxfilters(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDevicesinactivitylimit(value);
      break;
    case 27:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowapi(value);
      break;
    case 28:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowstatsaccess(value);
      break;
    case 29:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowapistatsaccess(value);
      break;
    case 30:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowgeozoneapi(value);
      break;
    case 32:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowabtests(value);
      break;
    case 34:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowbackup(value);
      break;
    case 36:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowapplicationapi(value);
      break;
    case 37:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowremotepage(value);
      break;
    case 39:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowscheduling(value);
      break;
    case 40:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowcustomdata(value);
      break;
    case 41:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowmultilanguage(value);
      break;
    case 42:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowautoconfig(value);
      break;
    case 43:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowcsvmessage(value);
      break;
    case 44:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowcampaignapi(value);
      break;
    case 45:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowpushhistoryapi(value);
      break;
    case 46:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowtagsapi(value);
      break;
    case 47:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowpushbyuser(value);
      break;
    case 48:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowfilterapi(value);
      break;
    case 49:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowtwofactorauth(value);
      break;
    case 51:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowbroadcastmessagesegmentation(value);
      break;
    case 52:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowpushonevent(value);
      break;
    case 53:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowcompilefilter(value);
      break;
    case 54:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinsendrate(value);
      break;
    case 55:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxsendrate(value);
      break;
    case 56:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowsendtogeozone(value);
      break;
    case 57:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowuseiosnewsstand(value);
      break;
    case 58:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowgetusersdetails(value);
      break;
    case 59:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowgoaltracking(value);
      break;
    case 60:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowieplatformusage(value);
      break;
    case 65:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowinbox(value);
      break;
    case 66:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxemailtemplates(value);
      break;
    case 67:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxuserspecifictags(value);
      break;
    case 68:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowgdpr(value);
      break;
    case 69:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxverifyingemails(value);
      break;
    case 70:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxverifyingdomains(value);
      break;
    case 71:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowsendexternalstats(value);
      break;
    case 72:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowcustomrsspollinginterval(value);
      break;
    case 73:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowmetadata(value);
      break;
    case 75:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxpushoneventdelayindays(value);
      break;
    case 76:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAlloweventstatisticsapi(value);
      break;
    case 77:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowtagnotsetfilter(value);
      break;
    case 79:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowdebugmode(value);
      break;
    case 80:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowfbmessenger(value);
      break;
    case 82:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowtrackuninstalls(value);
      break;
    case 84:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEmailratecounteraggregateperiod(value);
      break;
    case 85:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEmailbounceratelimit(value);
      break;
    case 86:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEmailcomplaintratelimit(value);
      break;
    case 87:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowfrequencycapping(value);
      break;
    case 88:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxusersperdevice(value);
      break;
    case 89:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEmailsfreelimit(value);
      break;
    case 90:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEmailslimited(value);
      break;
    case 94:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowcontenttemplates(value);
      break;
    case 95:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowbaiduandroidplatformusage(value);
      break;
    case 97:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxinboxttldays(value);
      break;
    case 105:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMessagehistorystoreperiod(value);
      break;
    case 106:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowapigetmessagelog(value);
      break;
    case 107:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDetailactionhistorystoreperiod(value);
      break;
    case 108:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowcjwebhook(value);
      break;
    case 109:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowcjinapp(value);
      break;
    case 110:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowcjscheduledsegment(value);
      break;
    case 111:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowcjcontentpersonalization(value);
      break;
    case 112:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowcjsettags(value);
      break;
    case 113:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowcjdynamicdelay(value);
      break;
    case 114:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowcjsilenthours(value);
      break;
    case 115:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowcjfrequencycapping(value);
      break;
    case 116:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowshowdeliverystatistics(value);
      break;
    case 117:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowrfmsegments(value);
      break;
    case 118:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowbesttimetosend(value);
      break;
    case 119:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAlloweventsegmentation(value);
      break;
    case 120:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowsegmentsgroups(value);
      break;
    case 121:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowcustomerjourney(value);
      break;
    case 122:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowcjsms(value);
      break;
    case 123:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowcjapientry(value);
      break;
    case 124:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowcjdynamicsettagsinupdateprofile(value);
      break;
    case 125:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowcjaddbranchesinwaitfortrigger(value);
      break;
    case 126:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAlloweventsfunnel(value);
      break;
    case 127:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowchannelssection(value);
      break;
    case 128:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowcjemailbcc(value);
      break;
    case 129:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEmailfilestoreperiod(value);
      break;
    case 130:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowwhatsapp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getIslocked();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMaxcampaigns();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getMaxdeeplinks();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getMaxapplicationgroups();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getMaxapps();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getMaxtags();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getMaxgeozones();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getMaxdevices();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getMaxusers();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getMaxapitokens();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getMaxpresets();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getMaxtestdevices();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getMaxgeozonerange();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getMaxrssfeeds();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getMaxautopushes();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getMaxioscategories();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getMaxtwitterfeeds();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
  f = message.getMaxinapps();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getMaxevents();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
  f = message.getMaxcreatemessage();
  if (f !== 0) {
    writer.writeInt64(
      22,
      f
    );
  }
  f = message.getMaxrichmedia();
  if (f !== 0) {
    writer.writeInt64(
      23,
      f
    );
  }
  f = message.getMaxpreparedfilters();
  if (f !== 0) {
    writer.writeInt64(
      24,
      f
    );
  }
  f = message.getMaxfilters();
  if (f !== 0) {
    writer.writeInt64(
      25,
      f
    );
  }
  f = message.getDevicesinactivitylimit();
  if (f !== 0) {
    writer.writeInt64(
      26,
      f
    );
  }
  f = message.getAllowapi();
  if (f) {
    writer.writeBool(
      27,
      f
    );
  }
  f = message.getAllowstatsaccess();
  if (f) {
    writer.writeBool(
      28,
      f
    );
  }
  f = message.getAllowapistatsaccess();
  if (f) {
    writer.writeBool(
      29,
      f
    );
  }
  f = message.getAllowgeozoneapi();
  if (f) {
    writer.writeBool(
      30,
      f
    );
  }
  f = message.getAllowabtests();
  if (f) {
    writer.writeBool(
      32,
      f
    );
  }
  f = message.getAllowbackup();
  if (f) {
    writer.writeBool(
      34,
      f
    );
  }
  f = message.getAllowapplicationapi();
  if (f) {
    writer.writeBool(
      36,
      f
    );
  }
  f = message.getAllowremotepage();
  if (f) {
    writer.writeBool(
      37,
      f
    );
  }
  f = message.getAllowscheduling();
  if (f) {
    writer.writeBool(
      39,
      f
    );
  }
  f = message.getAllowcustomdata();
  if (f) {
    writer.writeBool(
      40,
      f
    );
  }
  f = message.getAllowmultilanguage();
  if (f) {
    writer.writeBool(
      41,
      f
    );
  }
  f = message.getAllowautoconfig();
  if (f) {
    writer.writeBool(
      42,
      f
    );
  }
  f = message.getAllowcsvmessage();
  if (f) {
    writer.writeBool(
      43,
      f
    );
  }
  f = message.getAllowcampaignapi();
  if (f) {
    writer.writeBool(
      44,
      f
    );
  }
  f = message.getAllowpushhistoryapi();
  if (f) {
    writer.writeBool(
      45,
      f
    );
  }
  f = message.getAllowtagsapi();
  if (f) {
    writer.writeBool(
      46,
      f
    );
  }
  f = message.getAllowpushbyuser();
  if (f) {
    writer.writeBool(
      47,
      f
    );
  }
  f = message.getAllowfilterapi();
  if (f) {
    writer.writeBool(
      48,
      f
    );
  }
  f = message.getAllowtwofactorauth();
  if (f) {
    writer.writeBool(
      49,
      f
    );
  }
  f = message.getAllowbroadcastmessagesegmentation();
  if (f) {
    writer.writeBool(
      51,
      f
    );
  }
  f = message.getAllowpushonevent();
  if (f) {
    writer.writeBool(
      52,
      f
    );
  }
  f = message.getAllowcompilefilter();
  if (f) {
    writer.writeBool(
      53,
      f
    );
  }
  f = message.getMinsendrate();
  if (f !== 0) {
    writer.writeInt64(
      54,
      f
    );
  }
  f = message.getMaxsendrate();
  if (f !== 0) {
    writer.writeInt64(
      55,
      f
    );
  }
  f = message.getAllowsendtogeozone();
  if (f) {
    writer.writeBool(
      56,
      f
    );
  }
  f = message.getAllowuseiosnewsstand();
  if (f) {
    writer.writeBool(
      57,
      f
    );
  }
  f = message.getAllowgetusersdetails();
  if (f) {
    writer.writeBool(
      58,
      f
    );
  }
  f = message.getAllowgoaltracking();
  if (f) {
    writer.writeBool(
      59,
      f
    );
  }
  f = message.getAllowieplatformusage();
  if (f) {
    writer.writeBool(
      60,
      f
    );
  }
  f = message.getAllowinbox();
  if (f) {
    writer.writeBool(
      65,
      f
    );
  }
  f = message.getMaxemailtemplates();
  if (f !== 0) {
    writer.writeInt64(
      66,
      f
    );
  }
  f = message.getMaxuserspecifictags();
  if (f !== 0) {
    writer.writeInt64(
      67,
      f
    );
  }
  f = message.getAllowgdpr();
  if (f) {
    writer.writeBool(
      68,
      f
    );
  }
  f = message.getMaxverifyingemails();
  if (f !== 0) {
    writer.writeInt64(
      69,
      f
    );
  }
  f = message.getMaxverifyingdomains();
  if (f !== 0) {
    writer.writeInt64(
      70,
      f
    );
  }
  f = message.getAllowsendexternalstats();
  if (f) {
    writer.writeBool(
      71,
      f
    );
  }
  f = message.getAllowcustomrsspollinginterval();
  if (f) {
    writer.writeBool(
      72,
      f
    );
  }
  f = message.getAllowmetadata();
  if (f) {
    writer.writeBool(
      73,
      f
    );
  }
  f = message.getMaxpushoneventdelayindays();
  if (f !== 0) {
    writer.writeInt64(
      75,
      f
    );
  }
  f = message.getAlloweventstatisticsapi();
  if (f) {
    writer.writeBool(
      76,
      f
    );
  }
  f = message.getAllowtagnotsetfilter();
  if (f) {
    writer.writeBool(
      77,
      f
    );
  }
  f = message.getAllowdebugmode();
  if (f) {
    writer.writeBool(
      79,
      f
    );
  }
  f = message.getAllowfbmessenger();
  if (f) {
    writer.writeBool(
      80,
      f
    );
  }
  f = message.getAllowtrackuninstalls();
  if (f) {
    writer.writeBool(
      82,
      f
    );
  }
  f = message.getEmailratecounteraggregateperiod();
  if (f !== 0) {
    writer.writeInt64(
      84,
      f
    );
  }
  f = message.getEmailbounceratelimit();
  if (f !== 0) {
    writer.writeInt64(
      85,
      f
    );
  }
  f = message.getEmailcomplaintratelimit();
  if (f !== 0) {
    writer.writeInt64(
      86,
      f
    );
  }
  f = message.getAllowfrequencycapping();
  if (f) {
    writer.writeBool(
      87,
      f
    );
  }
  f = message.getMaxusersperdevice();
  if (f !== 0) {
    writer.writeInt64(
      88,
      f
    );
  }
  f = message.getEmailsfreelimit();
  if (f !== 0) {
    writer.writeInt64(
      89,
      f
    );
  }
  f = message.getEmailslimited();
  if (f) {
    writer.writeBool(
      90,
      f
    );
  }
  f = message.getAllowcontenttemplates();
  if (f) {
    writer.writeBool(
      94,
      f
    );
  }
  f = message.getAllowbaiduandroidplatformusage();
  if (f) {
    writer.writeBool(
      95,
      f
    );
  }
  f = message.getMaxinboxttldays();
  if (f !== 0) {
    writer.writeInt64(
      97,
      f
    );
  }
  f = message.getMessagehistorystoreperiod();
  if (f !== 0) {
    writer.writeInt64(
      105,
      f
    );
  }
  f = message.getAllowapigetmessagelog();
  if (f) {
    writer.writeBool(
      106,
      f
    );
  }
  f = message.getDetailactionhistorystoreperiod();
  if (f !== 0) {
    writer.writeInt64(
      107,
      f
    );
  }
  f = message.getAllowcjwebhook();
  if (f) {
    writer.writeBool(
      108,
      f
    );
  }
  f = message.getAllowcjinapp();
  if (f) {
    writer.writeBool(
      109,
      f
    );
  }
  f = message.getAllowcjscheduledsegment();
  if (f) {
    writer.writeBool(
      110,
      f
    );
  }
  f = message.getAllowcjcontentpersonalization();
  if (f) {
    writer.writeBool(
      111,
      f
    );
  }
  f = message.getAllowcjsettags();
  if (f) {
    writer.writeBool(
      112,
      f
    );
  }
  f = message.getAllowcjdynamicdelay();
  if (f) {
    writer.writeBool(
      113,
      f
    );
  }
  f = message.getAllowcjsilenthours();
  if (f) {
    writer.writeBool(
      114,
      f
    );
  }
  f = message.getAllowcjfrequencycapping();
  if (f) {
    writer.writeBool(
      115,
      f
    );
  }
  f = message.getAllowshowdeliverystatistics();
  if (f) {
    writer.writeBool(
      116,
      f
    );
  }
  f = message.getAllowrfmsegments();
  if (f) {
    writer.writeBool(
      117,
      f
    );
  }
  f = message.getAllowbesttimetosend();
  if (f) {
    writer.writeBool(
      118,
      f
    );
  }
  f = message.getAlloweventsegmentation();
  if (f) {
    writer.writeBool(
      119,
      f
    );
  }
  f = message.getAllowsegmentsgroups();
  if (f) {
    writer.writeBool(
      120,
      f
    );
  }
  f = message.getAllowcustomerjourney();
  if (f) {
    writer.writeBool(
      121,
      f
    );
  }
  f = message.getAllowcjsms();
  if (f) {
    writer.writeBool(
      122,
      f
    );
  }
  f = message.getAllowcjapientry();
  if (f) {
    writer.writeBool(
      123,
      f
    );
  }
  f = message.getAllowcjdynamicsettagsinupdateprofile();
  if (f) {
    writer.writeBool(
      124,
      f
    );
  }
  f = message.getAllowcjaddbranchesinwaitfortrigger();
  if (f) {
    writer.writeBool(
      125,
      f
    );
  }
  f = message.getAlloweventsfunnel();
  if (f) {
    writer.writeBool(
      126,
      f
    );
  }
  f = message.getAllowchannelssection();
  if (f) {
    writer.writeBool(
      127,
      f
    );
  }
  f = message.getAllowcjemailbcc();
  if (f) {
    writer.writeBool(
      128,
      f
    );
  }
  f = message.getEmailfilestoreperiod();
  if (f !== 0) {
    writer.writeInt64(
      129,
      f
    );
  }
  f = message.getAllowwhatsapp();
  if (f) {
    writer.writeBool(
      130,
      f
    );
  }
};


/**
 * optional uint64 ID = 1;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool IsLocked = 2;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getIslocked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setIslocked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional int64 MaxCampaigns = 3;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxcampaigns = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxcampaigns = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 MaxDeeplinks = 4;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxdeeplinks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxdeeplinks = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 MaxApplicationGroups = 5;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxapplicationgroups = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxapplicationgroups = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 MaxApps = 6;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxapps = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxapps = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 MaxTags = 7;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxtags = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxtags = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 MaxGeozones = 8;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxgeozones = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxgeozones = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 MaxDevices = 9;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxdevices = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxdevices = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 MaxUsers = 10;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxusers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxusers = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 MaxApiTokens = 11;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxapitokens = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxapitokens = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 MaxPresets = 12;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxpresets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxpresets = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 MaxTestDevices = 13;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxtestdevices = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxtestdevices = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 MaxGeozoneRange = 14;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxgeozonerange = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxgeozonerange = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 MaxRssFeeds = 16;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxrssfeeds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxrssfeeds = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int64 MaxAutoPushes = 17;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxautopushes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxautopushes = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int64 MaxIOSCategories = 18;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxioscategories = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxioscategories = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int64 MaxTwitterFeeds = 19;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxtwitterfeeds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxtwitterfeeds = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int64 MaxInapps = 20;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxinapps = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxinapps = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional int64 MaxEvents = 21;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxevents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxevents = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional int64 MaxCreateMessage = 22;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxcreatemessage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxcreatemessage = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional int64 MaxRichmedia = 23;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxrichmedia = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxrichmedia = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional int64 MaxPreparedFilters = 24;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxpreparedfilters = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxpreparedfilters = function(value) {
  return jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional int64 MaxFilters = 25;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxfilters = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxfilters = function(value) {
  return jspb.Message.setProto3IntField(this, 25, value);
};


/**
 * optional int64 DevicesInactivityLimit = 26;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getDevicesinactivitylimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setDevicesinactivitylimit = function(value) {
  return jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * optional bool AllowApi = 27;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowapi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 27, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowapi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 27, value);
};


/**
 * optional bool AllowStatsAccess = 28;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowstatsaccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 28, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowstatsaccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 28, value);
};


/**
 * optional bool AllowApiStatsAccess = 29;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowapistatsaccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 29, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowapistatsaccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 29, value);
};


/**
 * optional bool AllowGeozoneApi = 30;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowgeozoneapi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 30, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowgeozoneapi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 30, value);
};


/**
 * optional bool AllowABTests = 32;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowabtests = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 32, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowabtests = function(value) {
  return jspb.Message.setProto3BooleanField(this, 32, value);
};


/**
 * optional bool AllowBackup = 34;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowbackup = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 34, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowbackup = function(value) {
  return jspb.Message.setProto3BooleanField(this, 34, value);
};


/**
 * optional bool AllowApplicationApi = 36;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowapplicationapi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 36, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowapplicationapi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 36, value);
};


/**
 * optional bool AllowRemotePage = 37;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowremotepage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 37, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowremotepage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 37, value);
};


/**
 * optional bool AllowScheduling = 39;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowscheduling = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 39, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowscheduling = function(value) {
  return jspb.Message.setProto3BooleanField(this, 39, value);
};


/**
 * optional bool AllowCustomData = 40;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowcustomdata = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 40, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowcustomdata = function(value) {
  return jspb.Message.setProto3BooleanField(this, 40, value);
};


/**
 * optional bool AllowMultiLanguage = 41;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowmultilanguage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 41, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowmultilanguage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 41, value);
};


/**
 * optional bool AllowAutoConfig = 42;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowautoconfig = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 42, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowautoconfig = function(value) {
  return jspb.Message.setProto3BooleanField(this, 42, value);
};


/**
 * optional bool AllowCsvMessage = 43;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowcsvmessage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 43, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowcsvmessage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 43, value);
};


/**
 * optional bool AllowCampaignApi = 44;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowcampaignapi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 44, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowcampaignapi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 44, value);
};


/**
 * optional bool AllowPushHistoryApi = 45;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowpushhistoryapi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 45, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowpushhistoryapi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 45, value);
};


/**
 * optional bool AllowTagsApi = 46;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowtagsapi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 46, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowtagsapi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 46, value);
};


/**
 * optional bool AllowPushByUser = 47;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowpushbyuser = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 47, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowpushbyuser = function(value) {
  return jspb.Message.setProto3BooleanField(this, 47, value);
};


/**
 * optional bool AllowFilterApi = 48;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowfilterapi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 48, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowfilterapi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 48, value);
};


/**
 * optional bool AllowTwoFactorAuth = 49;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowtwofactorauth = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 49, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowtwofactorauth = function(value) {
  return jspb.Message.setProto3BooleanField(this, 49, value);
};


/**
 * optional bool AllowBroadcastMessageSegmentation = 51;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowbroadcastmessagesegmentation = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 51, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowbroadcastmessagesegmentation = function(value) {
  return jspb.Message.setProto3BooleanField(this, 51, value);
};


/**
 * optional bool AllowPushOnEvent = 52;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowpushonevent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 52, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowpushonevent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 52, value);
};


/**
 * optional bool AllowCompileFilter = 53;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowcompilefilter = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 53, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowcompilefilter = function(value) {
  return jspb.Message.setProto3BooleanField(this, 53, value);
};


/**
 * optional int64 MinSendRate = 54;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMinsendrate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 54, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMinsendrate = function(value) {
  return jspb.Message.setProto3IntField(this, 54, value);
};


/**
 * optional int64 MaxSendRate = 55;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxsendrate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 55, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxsendrate = function(value) {
  return jspb.Message.setProto3IntField(this, 55, value);
};


/**
 * optional bool AllowSendToGeozone = 56;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowsendtogeozone = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 56, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowsendtogeozone = function(value) {
  return jspb.Message.setProto3BooleanField(this, 56, value);
};


/**
 * optional bool AllowUseIosNewsstand = 57;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowuseiosnewsstand = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 57, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowuseiosnewsstand = function(value) {
  return jspb.Message.setProto3BooleanField(this, 57, value);
};


/**
 * optional bool AllowGetUsersDetails = 58;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowgetusersdetails = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 58, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowgetusersdetails = function(value) {
  return jspb.Message.setProto3BooleanField(this, 58, value);
};


/**
 * optional bool AllowGoalTracking = 59;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowgoaltracking = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 59, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowgoaltracking = function(value) {
  return jspb.Message.setProto3BooleanField(this, 59, value);
};


/**
 * optional bool AllowIePlatformUsage = 60;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowieplatformusage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 60, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowieplatformusage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 60, value);
};


/**
 * optional bool AllowInbox = 65;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowinbox = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 65, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowinbox = function(value) {
  return jspb.Message.setProto3BooleanField(this, 65, value);
};


/**
 * optional int64 MaxEmailTemplates = 66;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxemailtemplates = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 66, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxemailtemplates = function(value) {
  return jspb.Message.setProto3IntField(this, 66, value);
};


/**
 * optional int64 MaxUserSpecificTags = 67;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxuserspecifictags = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 67, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxuserspecifictags = function(value) {
  return jspb.Message.setProto3IntField(this, 67, value);
};


/**
 * optional bool AllowGdpr = 68;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowgdpr = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 68, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowgdpr = function(value) {
  return jspb.Message.setProto3BooleanField(this, 68, value);
};


/**
 * optional int64 MaxVerifyingEmails = 69;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxverifyingemails = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 69, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxverifyingemails = function(value) {
  return jspb.Message.setProto3IntField(this, 69, value);
};


/**
 * optional int64 MaxVerifyingDomains = 70;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxverifyingdomains = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 70, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxverifyingdomains = function(value) {
  return jspb.Message.setProto3IntField(this, 70, value);
};


/**
 * optional bool AllowSendExternalStats = 71;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowsendexternalstats = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 71, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowsendexternalstats = function(value) {
  return jspb.Message.setProto3BooleanField(this, 71, value);
};


/**
 * optional bool AllowCustomRssPollingInterval = 72;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowcustomrsspollinginterval = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 72, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowcustomrsspollinginterval = function(value) {
  return jspb.Message.setProto3BooleanField(this, 72, value);
};


/**
 * optional bool AllowMetadata = 73;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowmetadata = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 73, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowmetadata = function(value) {
  return jspb.Message.setProto3BooleanField(this, 73, value);
};


/**
 * optional int64 MaxPushOnEventDelayInDays = 75;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxpushoneventdelayindays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 75, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxpushoneventdelayindays = function(value) {
  return jspb.Message.setProto3IntField(this, 75, value);
};


/**
 * optional bool AllowEventStatisticsApi = 76;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAlloweventstatisticsapi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 76, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAlloweventstatisticsapi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 76, value);
};


/**
 * optional bool AllowTagNotSetFilter = 77;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowtagnotsetfilter = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 77, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowtagnotsetfilter = function(value) {
  return jspb.Message.setProto3BooleanField(this, 77, value);
};


/**
 * optional bool AllowDebugMode = 79;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowdebugmode = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 79, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowdebugmode = function(value) {
  return jspb.Message.setProto3BooleanField(this, 79, value);
};


/**
 * optional bool AllowFbMessenger = 80;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowfbmessenger = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 80, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowfbmessenger = function(value) {
  return jspb.Message.setProto3BooleanField(this, 80, value);
};


/**
 * optional bool AllowTrackUninstalls = 82;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowtrackuninstalls = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 82, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowtrackuninstalls = function(value) {
  return jspb.Message.setProto3BooleanField(this, 82, value);
};


/**
 * optional int64 EmailRateCounterAggregatePeriod = 84;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getEmailratecounteraggregateperiod = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 84, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setEmailratecounteraggregateperiod = function(value) {
  return jspb.Message.setProto3IntField(this, 84, value);
};


/**
 * optional int64 EmailBounceRateLimit = 85;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getEmailbounceratelimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 85, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setEmailbounceratelimit = function(value) {
  return jspb.Message.setProto3IntField(this, 85, value);
};


/**
 * optional int64 EmailComplaintRateLimit = 86;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getEmailcomplaintratelimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 86, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setEmailcomplaintratelimit = function(value) {
  return jspb.Message.setProto3IntField(this, 86, value);
};


/**
 * optional bool AllowFrequencyCapping = 87;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowfrequencycapping = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 87, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowfrequencycapping = function(value) {
  return jspb.Message.setProto3BooleanField(this, 87, value);
};


/**
 * optional int64 MaxUsersPerDevice = 88;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxusersperdevice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 88, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxusersperdevice = function(value) {
  return jspb.Message.setProto3IntField(this, 88, value);
};


/**
 * optional int64 EmailsFreeLimit = 89;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getEmailsfreelimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 89, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setEmailsfreelimit = function(value) {
  return jspb.Message.setProto3IntField(this, 89, value);
};


/**
 * optional bool EmailsLimited = 90;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getEmailslimited = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 90, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setEmailslimited = function(value) {
  return jspb.Message.setProto3BooleanField(this, 90, value);
};


/**
 * optional bool AllowContentTemplates = 94;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowcontenttemplates = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 94, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowcontenttemplates = function(value) {
  return jspb.Message.setProto3BooleanField(this, 94, value);
};


/**
 * optional bool AllowBaiduAndroidPlatformUsage = 95;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowbaiduandroidplatformusage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 95, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowbaiduandroidplatformusage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 95, value);
};


/**
 * optional int64 MaxInboxTtlDays = 97;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMaxinboxttldays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 97, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMaxinboxttldays = function(value) {
  return jspb.Message.setProto3IntField(this, 97, value);
};


/**
 * optional int64 MessageHistoryStorePeriod = 105;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getMessagehistorystoreperiod = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 105, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setMessagehistorystoreperiod = function(value) {
  return jspb.Message.setProto3IntField(this, 105, value);
};


/**
 * optional bool AllowApiGetMessageLog = 106;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowapigetmessagelog = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 106, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowapigetmessagelog = function(value) {
  return jspb.Message.setProto3BooleanField(this, 106, value);
};


/**
 * optional int64 DetailActionHistoryStorePeriod = 107;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getDetailactionhistorystoreperiod = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 107, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setDetailactionhistorystoreperiod = function(value) {
  return jspb.Message.setProto3IntField(this, 107, value);
};


/**
 * optional bool AllowCjWebhook = 108;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowcjwebhook = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 108, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowcjwebhook = function(value) {
  return jspb.Message.setProto3BooleanField(this, 108, value);
};


/**
 * optional bool AllowCjInapp = 109;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowcjinapp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 109, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowcjinapp = function(value) {
  return jspb.Message.setProto3BooleanField(this, 109, value);
};


/**
 * optional bool AllowCjScheduledSegment = 110;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowcjscheduledsegment = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 110, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowcjscheduledsegment = function(value) {
  return jspb.Message.setProto3BooleanField(this, 110, value);
};


/**
 * optional bool AllowCjContentPersonalization = 111;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowcjcontentpersonalization = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 111, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowcjcontentpersonalization = function(value) {
  return jspb.Message.setProto3BooleanField(this, 111, value);
};


/**
 * optional bool AllowCjSetTags = 112;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowcjsettags = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 112, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowcjsettags = function(value) {
  return jspb.Message.setProto3BooleanField(this, 112, value);
};


/**
 * optional bool AllowCjDynamicDelay = 113;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowcjdynamicdelay = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 113, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowcjdynamicdelay = function(value) {
  return jspb.Message.setProto3BooleanField(this, 113, value);
};


/**
 * optional bool AllowCjSilentHours = 114;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowcjsilenthours = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 114, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowcjsilenthours = function(value) {
  return jspb.Message.setProto3BooleanField(this, 114, value);
};


/**
 * optional bool AllowCjFrequencyCapping = 115;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowcjfrequencycapping = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 115, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowcjfrequencycapping = function(value) {
  return jspb.Message.setProto3BooleanField(this, 115, value);
};


/**
 * optional bool AllowShowDeliveryStatistics = 116;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowshowdeliverystatistics = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 116, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowshowdeliverystatistics = function(value) {
  return jspb.Message.setProto3BooleanField(this, 116, value);
};


/**
 * optional bool AllowRFMSegments = 117;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowrfmsegments = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 117, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowrfmsegments = function(value) {
  return jspb.Message.setProto3BooleanField(this, 117, value);
};


/**
 * optional bool AllowBestTimeToSend = 118;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowbesttimetosend = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 118, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowbesttimetosend = function(value) {
  return jspb.Message.setProto3BooleanField(this, 118, value);
};


/**
 * optional bool AllowEventSegmentation = 119;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAlloweventsegmentation = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 119, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAlloweventsegmentation = function(value) {
  return jspb.Message.setProto3BooleanField(this, 119, value);
};


/**
 * optional bool AllowSegmentsGroups = 120;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowsegmentsgroups = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 120, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowsegmentsgroups = function(value) {
  return jspb.Message.setProto3BooleanField(this, 120, value);
};


/**
 * optional bool AllowCustomerJourney = 121;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowcustomerjourney = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 121, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowcustomerjourney = function(value) {
  return jspb.Message.setProto3BooleanField(this, 121, value);
};


/**
 * optional bool AllowCjSMS = 122;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowcjsms = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 122, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowcjsms = function(value) {
  return jspb.Message.setProto3BooleanField(this, 122, value);
};


/**
 * optional bool AllowCjApiEntry = 123;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowcjapientry = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 123, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowcjapientry = function(value) {
  return jspb.Message.setProto3BooleanField(this, 123, value);
};


/**
 * optional bool AllowCjDynamicSetTagsInUpdateProfile = 124;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowcjdynamicsettagsinupdateprofile = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 124, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowcjdynamicsettagsinupdateprofile = function(value) {
  return jspb.Message.setProto3BooleanField(this, 124, value);
};


/**
 * optional bool AllowCjAddBranchesInWaitForTrigger = 125;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowcjaddbranchesinwaitfortrigger = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 125, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowcjaddbranchesinwaitfortrigger = function(value) {
  return jspb.Message.setProto3BooleanField(this, 125, value);
};


/**
 * optional bool AllowEventsFunnel = 126;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAlloweventsfunnel = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 126, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAlloweventsfunnel = function(value) {
  return jspb.Message.setProto3BooleanField(this, 126, value);
};


/**
 * optional bool AllowChannelsSection = 127;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowchannelssection = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 127, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowchannelssection = function(value) {
  return jspb.Message.setProto3BooleanField(this, 127, value);
};


/**
 * optional bool AllowCjEmailBcc = 128;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowcjemailbcc = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 128, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowcjemailbcc = function(value) {
  return jspb.Message.setProto3BooleanField(this, 128, value);
};


/**
 * optional int64 EmailFileStorePeriod = 129;
 * @return {number}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getEmailfilestoreperiod = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 129, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setEmailfilestoreperiod = function(value) {
  return jspb.Message.setProto3IntField(this, 129, value);
};


/**
 * optional bool AllowWhatsApp = 130;
 * @return {boolean}
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.getAllowwhatsapp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 130, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} returns this
 */
proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue.prototype.setAllowwhatsapp = function(value) {
  return jspb.Message.setProto3BooleanField(this, 130, value);
};


goog.object.extend(exports, proto.pushwoosh.objects.restrictionValues.v1);
